import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const AdminHomeButton = () => {
  const { isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (!isAdmin || location.pathname === '/admin/login') return null;

  const goHome = () => {
    if (location.pathname === '/admin') {
      window.dispatchEvent(new Event('admin:home'));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/admin');
    }
  };

  return (
    <button
      onClick={goHome}
      className="fixed z-[60] bottom-20 right-4 sm:bottom-6 sm:right-6 h-12 pl-4 pr-5 rounded-full bg-[#12121A]/90 backdrop-blur-md border border-violet-500/40 text-white text-sm font-medium flex items-center gap-2 shadow-lg shadow-violet-500/20 hover:bg-violet-500/20 hover:border-violet-400 active:scale-95 transition-[background-color,border-color,transform] duration-200"
      aria-label="Back to admin dashboard"
      data-testid="admin-home-fab"
    >
      <LayoutDashboard size={18} className="text-violet-400" />
      <span>Dashboard</span>
    </button>
  );
};
